const normalizeStatus = (status?: string) =>
  (status || "").trim().toLowerCase().replace(/[\s_-]+/g, "");

export const getDisplayStatus = (status?: string | null) => {
  const normalized = normalizeStatus(status || undefined);

  if (["online", "running", "ready", "available", "healthy"].includes(normalized)) {
    return "Online";
  }

  if (["offline", "stopped"].includes(normalized)) {
    return "Offline";
  }

  if (normalized === "unavailable") {
    return "Unavailable";
  }

  return status || undefined;
};

export const getStatusTextClass = (status?: string) => {
  const normalized = normalizeStatus(status);

  if (["online", "running", "available", "ready", "healthy", "enabled", "succeeded", "success"].includes(normalized)) {
    // Darker than Prestia's #009b48, which is under 4.5:1 on white at this size
    return "font-bold text-[#007a39]";
  }

  if (["offline", "stopped", "unavailable", "failed", "error", "disabled"].includes(normalized)) {
    return "font-bold text-[#e12b38]";
  }

  if (["starting", "stopping", "updating", "queued", "pending", "notconfigured"].includes(normalized)) {
    return "font-bold text-amber-700";
  }

  return "font-bold text-slate-700";
};
